// extracted by mini-css-extract-plugin
export default {"nav":"menu_nav__RgVcI","menuItem":"menu_menuItem__swmHK"};